import React, { useContext } from 'react'

import { Typography, Button, DialogTitle, DialogContent, Box, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import { useHistory } from 'react-router-dom'

import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle'
import useAuthContext from 'contextApi/AuthContext'

import 'perfect-scrollbar/css/perfect-scrollbar.css'

const useStyles = makeStyles(styles)
export default function ModalTimeReturn({
  closeModalDeclaration,
  numberOfPendingReturns,
  setOpenModalReturn,
  returnUniqueId,
}) {
  const { userLoggedin } = useContext(useAuthContext)
  const history = useHistory()
  const classes = useStyles()

  const redirection = () => {
    setOpenModalReturn(false)
    history.push(`/admin/returns?uniqueId=${returnUniqueId}`)
  }
  return (
    <>
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.dialogTitle}>
          Tienes actividad pendiente
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={closeModalDeclaration}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.headerBox}>
          <Box className={classes.counter}>
            <Typography className={classes.counterText}>{numberOfPendingReturns}</Typography>
          </Box>
          <Typography className={classes.pendingText}>Devoluciones pendientes</Typography>
          <Button
            variant="text"
            color="primary"
            className={classes.linkButton}
            onClick={() => redirection()}
          >
            Gestionar
            <span className={classes.sizeIcon}>{`>`}</span>
          </Button>
        </Box>
        <Typography variant="body2" className={classes.messageName} style={{ display: 'block' }}>
          {`Hola `}
          <Typography variant="body1" style={{ fontWeight: 700, display: 'inline-block' }}>
            {` ${userLoggedin.firstName},  `}
          </Typography>
        </Typography>
        <Typography variant="body2" className={classes.message}>
          {`Recuerda que si es un caso de `}
          <Typography variant="body1" style={{ fontWeight: 700, display: 'inline-block' }}>
            {` Retracto tienes 2 días calendario `}
          </Typography>
          {` para gestionarlo, de lo contrario podría cargarse los costos asociados a estas órdenes.`}
        </Typography>

        <Typography variant="body2" className={classes.message}>
          Responder a tiempo fortalece la confianza con tus clientes y tu reputación en Luegopago.
        </Typography>
        <Typography variant="body1" className={classes.boldMessage}>
          ¡Contamos contigo!
        </Typography>
      </DialogContent>
    </>
  )
}
